import { Location, useLocation as useRouterLocation } from "react-router-dom"

export function useLocation<State extends any>(): Location<State | null> {
  const location = useRouterLocation()
  return location as Location<State>
}
